import React from 'react';
import { useTranslator } from '@jutro/locale';

import messages from './MLReinstatementContactUsPage.messages'


function MLReinstatementContactUsPage(){
    const translator = useTranslator();

    return(
        <div className="gw-page">
            <h2 className="section-header">{translator(messages.error)}</h2>
        </div>
    )
}

export default MLReinstatementContactUsPage;